import ErrorIcon from '@mui/icons-material/ErrorOutline';
import ELEMENT from 'common/element';

import './AccessDeniedError.scss';

function AccessDeniedError(): JSX.Element {
  return (
    <div data-test-id={ELEMENT.accessDeniedError} className="AccessDeniedError__Container">
      <div className="AccessDeniedError__Icon">
        <ErrorIcon />
      </div>
      <div className="AccessDeniedError__Body">
        <div className="AccessDeniedError__Title">Access Denied</div>
        <div className="AccessDeniedError__Message">
          Sorry, you don't have permission to view this page. Please contact your account admin to request access.
        </div>
      </div>
    </div>
  );
}

export default AccessDeniedError;
